import type { Book } from "./seed";

export type ApiIssue = Book["issues"][number] & { id?: string; bookSlug: string; bookTitle?: string; imageKey?: string; publishedAt?: string };
export type ApiTag = { id: string; slug: string; label: string };
export type ApiCollectionPhoto = { id: string; imageKey: string; image: string; caption: string; alt: string; date: string; sortOrder: number };
export type ApiCollection = { id: string; slug: string; title: string; description: string; createdAt: string; photos: ApiCollectionPhoto[] };
export type ApiUsMoment = { id: string; date: string; title: string; note: string; sortOrder: number };
export type ApiUsPhotograph = { id: string; imageKey: string; image: string; alt: string; date: string; note: string; sortOrder: number };
export type ApiUs = { startDate: string; partnerA: string; partnerB: string; headingNote: string; heroImageKey: string; heroImage: string | null; moments: ApiUsMoment[]; photographs: ApiUsPhotograph[] };

const configuredBase = ((import.meta.env.VITE_API_BASE_URL as string | undefined) ?? "https://qblog-api.cqmike0315.workers.dev").replace(/\/$/, "");

export async function apiRequest<T>(path: string, init: RequestInit = {}): Promise<T> {
	const adminToken = window.localStorage.getItem("qblog_admin_token");
	const response = await fetch(`${configuredBase}/api${path}`, {
		...init,
		credentials: "include",
		headers: {
			...(init.body instanceof FormData ? {} : { "Content-Type": "application/json" }),
			...(adminToken ? { Authorization: `Bearer ${adminToken}` } : {}),
			...init.headers,
		},
	});
	if (!response.ok) {
		const payload = await response.json().catch(() => ({}));
		throw new Error(payload.error || `Request failed (${response.status})`);
	}
	if (response.status === 204) return undefined as T;
	return response.json() as Promise<T>;
}

export function checkAdminSession() {
	return apiRequest<{ authenticated: boolean }>("/auth/me").then(({ authenticated }) => authenticated);
}

export function fetchBooks() { return apiRequest<Book[]>("/books"); }
export function fetchIssues() { return apiRequest<ApiIssue[]>("/issues"); }
export function fetchTags() { return apiRequest<ApiTag[]>("/tags"); }
export function fetchCollections() { return apiRequest<ApiCollection[]>("/collections"); }
export function fetchCollection(slug: string) { return apiRequest<ApiCollection>(`/collections/${encodeURIComponent(slug)}`); }
export function fetchUs() { return apiRequest<ApiUs>("/us"); }

export async function uploadMedia(file: File) {
	const form = new FormData();
	form.append("file", file);
	return apiRequest<{ key: string; url: string }>("/media", { method: "POST", body: form });
}
